<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableEventResourceListData"
      style="width: 100%;"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableEventResource = {};
export default {
  name: "TableEventResource",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      columns: [
        {
          title: this.$t("RAM.AWS.Event.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.Event.accountID"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.AWS.Event.region"),
          key: "region"
        },
        {
          title: this.$t("RAM.AWS.Event.resource"),
          key: "resourceTypeString"
        },
        {
          title: this.$t("RAM.AWS.Event.resourceId"),
          key: "resourceId"
        },
        {
          title: this.$t("RAM.AWS.Event.instanceType"),
          key: "instanceType"
        },
        {
          title: this.$t("RAM.AWS.Event.eventType"),
          key: "eventTypeString"
        },
        {
          title: this.$t("RAM.AWS.Event.beforeChangeStatus"),
          key: "beforeChangeState"
        },
        {
          title: this.$t("RAM.AWS.Event.afterChangeStatus"),
          key: "afterChangeState"
        },
        {
          title: this.$t("RAM.AWS.Event.eventTime"),
          key: "eventTime"
        }
      ],
      tableEventResourceListData: []
    };
  },
  beforeCreate: function() {
    tableEventResource = this;
  },
  created() {
    eventBus.$on("companyId", function(val) {
      tableEventResource.companyId = val;
    });
    eventBus.$on("accountIds", function(val) {
      tableEventResource.accountIds = val;
    });
    eventBus.$on("resourceType", function(val) {
      tableEventResource.resourceType = val;
    });
    eventBus.$on("eventTypes", function(val) {
      tableEventResource.eventTypes = val;
    });
    eventBus.$on("timeList", function(val) {
      tableEventResource.timeList = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableEventResource.getEventResourceListData();
    },
    // 分页显示数据
    /****************************************************/
    getEventResourceListData: function() {
      tableEventResource.$api.event
        .page({
          companyId: tableEventResource.companyId,
          accountIds: tableEventResource.accountIds,
          resourceType: tableEventResource.resourceType,
          eventTypes: tableEventResource.eventTypes,
          timeList: tableEventResource.timeList,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.tableEventResourceListData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableEventResource.getEventResourceListData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableEventResource.getEventResourceListData();
    },
    // 销毁caseSearchID
    beforeDestroy: function() {}
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/event/TableEventResource.vue